import store from "../store";
import {
  setAllNotificationsSeen,
  setNotificationSeen
} from "../store/Notifications/actions";
import { notificationsActions } from "./constants";

export const setFcmToken = (token) => {
  sessionStorage.setItem("fcm-token", token);
};

export const getFcmToken = () => {
  return sessionStorage.getItem("fcm-token");
};

export const setUnseenNotificationsCount = (count) => {
  localStorage.setItem("unseen-notification-count", count);
};

export const handleNotificationClick = ({
  id,
  clickAction,
  actionId,
  isRead,
  navigate
}) => {
  if (clickAction) {
    const notificationsAction = notificationsActions.find(
      (action) => action.clickAction === clickAction
    );
    if (notificationsAction && notificationsAction.route) {
      navigate(
        actionId && notificationsAction.actionIdKey
          ? notificationsAction.route.replace(
              notificationsAction.actionIdKey,
              actionId
            )
          : notificationsAction.route
      );
    }
  }
  if (!isRead) {
    // Handle seen notificaiton logic
    store.dispatch(setNotificationSeen({ data: { Id: id } }));
  }
};

export const markAllNotificationsAsRead = ({ request }) => {
  store.dispatch(setAllNotificationsSeen({ request }));
};
